// REDUCER
import * as actionTypes from '../constants/actions';
// import rafScroll from '../utils/raf-scroll';
import events from 'events';
// import throttle from 'lodash/throttle';

const defaultState = {
	window: {
		width: getWidth(),
		height: getHeight(),
	},
	scroll: {
		register: registerScrollEvents,
		deregister: deregisterScrollEvents,
	},
};

let lastScroll = 0;
let lastTime = new Date().getTime();
export const BROWSER_SCROLLED = 'BROWSER_SCROLLED';

// ------------------------------------------------------------
// Scroll stuff
// ------------------------------------------------------------
export const EventEmitter = new events.EventEmitter();
EventEmitter.setMaxListeners(0); // removed memory leak warning

function registerScrollEvents(cb) {
	if (typeof cb === 'function') {
		EventEmitter.addListener(BROWSER_SCROLLED, cb);
	}
	// rafScroll.add(cb);
}

function deregisterScrollEvents(cb) {
	// console.log('before-remove: ' + EventEmitter.listenerCount(BROWSER_SCROLLED));
	if (typeof cb === 'function') {
		EventEmitter.removeListener(BROWSER_SCROLLED, cb);
	}
	// rafScroll.remove(cb);
	// console.log('after-remove: ' + EventEmitter.listenerCount(BROWSER_SCROLLED));
}

function emitScrollEvent() {
	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
	// const x = supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
	const scrollY = supportPageOffset ? window.pageYOffset : (isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop);
	const delta = scrollY - lastScroll;
	lastScroll = scrollY;

	const time = new Date().getTime();
	const deltaTime = time - lastTime;
	lastTime = time;

	EventEmitter.emit(BROWSER_SCROLLED, {
		scrollY,
		delta,
		deltaTime,
	});
}

// Global scroll listener - throttled to only run max every
// 60fps = 16.66ms pr. frame
window.addEventListener('scroll', emitScrollEvent, false); // throttle(emitScrollEvent, 8, { leading: true, trailing: true }), false);

// var perf = performance.now();
// var test = (event) => {
// 	// console.log('test: ' + (performance.now() - perf) + ' -- ' + event.scrollY);
// 	// perf = performance.now();
// 	console.log(event);
// };

// registerScrollEvents(test);
// registerScrollEvents(test);

// ------------------------------------------------------------
// Browser-size stuff
// ------------------------------------------------------------
// function setDocumentElement(body) {
// 	documentElement = body;
// }

function getWidth() {
	const documentElement = document.documentElement || document.body;
	if (documentElement && documentElement.clientHeight) {
		return documentElement.clientWidth;
	}

	return 0;
}

function getHeight() {
	const documentElement = document.documentElement || document.body;
	if (documentElement && documentElement.clientHeight) {
		return documentElement.clientHeight;
	}

	return 0;
}

function getWidthWiewport() {
	return window.window.innerWidth;
}

function getHeightWiewport() {
	return window.window.innerHeight;
}

function updateSizes(state) {
	// console.log(state);
	return {
		...state,
		window: {
			width: getWidth(),
			height: getHeight(),
			wpWidth: getWidthWiewport(),
			wpHeight: getHeightWiewport(),
		},
	};
}

// ------------------------------------------------------------
// Action switch
// ------------------------------------------------------------
export default function menuReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.BROWSER_RESIZE:
			return updateSizes(state);
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/browser.js
 **/